import request from '@/router/axios';
export const add = (row) => {
    return request({
        url: '/api/produce/transport-plan/insert',
        method: 'post',
        data: { ...row, planType: 2 }
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/transport-plan/update',
        method: 'post',
        data: row
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/transport-plan/select/id',
        method: 'get',
        params: {
            id,
            excludeShortTransfer: true,
        }
    })
}
export const getDaytransportplan = (params) => {
    return request({
        url: '/api/produce/transport-plan/selectPlanSummary',
        method: 'post',
        params: {
            ...params,
            businessType: 1,
        }
    })
}

export const send = (params) => {
    return request({
        url: '/api/msg/send',
        method: 'get',
        params
    })
}
/** 本页仅铁路入库（businessType=1）日计划（planType=2），与到货导入等日计划一致 */
export const getList = (params) => {
    return request({
        url: '/api/produce/transport-plan/select/page',
        method: 'get',
        params: {
            ...params,
            businessType: 1,
            planType: 2,
            excludeShortTransfer: true,
        }
    })
}
export const exportExcel = (params) => {
    return request({
        url: '/api/produce/transport-plan/export',
        method: 'get',
        params: {
            ...params,
            businessType: 1,
            planType: 2,
            excludeShortTransfer: true,
        },
        responseType: 'blob'
    })
}
export const remove = (ids) => {
    return request({
        url: '/api/produce/transport-plan/delete/ids',
        method: 'get',
        params: {
            ids
        }
    })
}


export const userSelect = (ids) => {
  return request({
    url: 'api/produce/blade-user/select/userList',
    method: 'get',
    params: {}
  })
}

export const userInsert = (row) => {
  return request({
    url: '/api/produce/blade-user/insert',
    method: 'post',
    data: row
  })
}
